<template>
    <div>
        <v-autocomplete
                v-model="item"
                :label="label"
                :readonly="readonly"
                outlined
                :items="items"
                item-value="id"
                item-text="name"
                :multiple="multiple"
                :color="color ? color : inputColor"
                :background-color="color ? `${color} lighten-5` : backgroundColor"
                :clearable="!readonly"
                @input="$emit('input', item)"
                dense
                :autofocus="autoFocus"
                hide-details="auto"
                :rules="rules"
        ></v-autocomplete>

        <input type="hidden"/>
    </div>
</template>


<script>
import useSharedData from "@/use/SharedData";
import {onMounted, ref} from "vue";

export default {
    name: "WAutocomplete",
    props: {
        value: [Number, Array, String, Boolean],
        multiple: Boolean,
        items: Array,
        label: String,
        color: String,
        disabled: Boolean,
        autoFocus: Boolean,
        readonly: Boolean,
        rules: Array,
        type: String,
    },
    setup(props) {
        const {inputColor, backgroundColor} = useSharedData();

        const item = ref(null);

        onMounted(() => item.value = props.value);

        return {
            inputColor,
            backgroundColor,
            item,
        }
    },
};
</script>